(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2xu-product-shelf"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initReel = (root) => {
      if (!root || root.dataset.xuReelReady === 'true') return;
      root.dataset.xuReelReady = 'true';
      const viewport = root.querySelector('[data-xu-reel-viewport]');
      const tabs = [...root.querySelectorAll('.xu-reel__tab')];
      const panels = [...root.querySelectorAll('[data-xu-reel-panel]')];
      const previous = root.querySelector('[data-xu-reel-prev]');
      const next = root.querySelector('[data-xu-reel-next]');
      const update = () => {
        previous.disabled = viewport.scrollLeft <= 1;
        next.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 2;
      };
      const select = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => panel.toggleAttribute('hidden', panel.dataset.xuReelPanel !== tab.dataset.xuReelGender));
        viewport.scrollTo({left: 0, behavior: 'instant'});
        update();
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const target = event.key === 'Home' ? tabs[0] : event.key === 'End' ? tabs.at(-1) : tabs[(index + 1) % tabs.length];
          select(target); target.focus();
        });
      });
      const step = () => Math.max(viewport.clientWidth * 0.82, 338);
      previous.addEventListener('click', () => viewport.scrollBy({left: -step(), behavior: 'smooth'}));
      next.addEventListener('click', () => viewport.scrollBy({left: step(), behavior: 'smooth'}));
      viewport.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(viewport);
      update();
    };
    const initAll = () => document.querySelectorAll('[data-xu-reel]').forEach(initReel);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once: true});
    else initAll();
    document.addEventListener('shopify:section:load', (event) => event.target?.querySelectorAll?.('[data-xu-reel]').forEach(initReel));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
